export default {
  name: 'FaqList',

  props: {
    faqListByCategories: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    faqCategories() {
      return Object.keys(this.faqListByCategories);
    },
  },
};
